import { Box, Stack, Typography } from '@mui/material';
import section1_bg from 'assets/img/ECommerce/section1_bg.png';
import section1_image from 'assets/img/ECommerce/section1_image.png';
import useDevice from 'hooks/useDevice';
import { JSX } from 'react';
import { DiNodejsSmall } from 'react-icons/di';
import { FaReact } from 'react-icons/fa';
import { RiFlutterFill } from 'react-icons/ri';

import theme from 'theme/index';
import { E_COMMERCE_STYLES } from './config';

export default function Section1(): JSX.Element {
  const { screenWidth } = useDevice();
  return (
    <Box
      sx={{
        background: 'linear-gradient(to bottom, #EBF0FF, #B5C6F4)',
        pt: 12,
      }}
    >
      <Stack
        spacing={1}
        maxWidth={E_COMMERCE_STYLES.container.maxWidth}
        mx={E_COMMERCE_STYLES.container.mx}
        sx={{
          px: 4,
        }}
      >
        <Typography
          variant="h1"
          fontWeight={500}
          lineHeight={1.1}
          fontSize={30}
          className="font-helvetica-bold"
        >
          Custom
          <br /> E-Commerce,
          <br />{' '}
          <span style={{ color: theme.palette.darkBlue.main }}>
            Built From
            <br /> Scratch!
          </span>
        </Typography>

        <Typography color="text.secondary" variant="body2" fontSize={13} className="font-helvetica">
          Enterprise-grade systems <br />
          <Stack direction={'row'} position={'relative'} zIndex={2}>
            built with &nbsp;
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  // background: "radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.6), transparent 60%),  radial-gradient(circle at 60% 50%, rgba(255, 255, 255, 0.4), transparent 70%), radial-gradient(circle at 50% 60%, rgba(255, 255, 255, 0.5), transparent 80%), #dbe8ff",
                  height: '33px',
                  width: '200px',
                  position: 'absolute',
                  opacity: '0.7',
                  left: '56px',
                  zIndex: -1,
                }}
              />
              <Typography
                variant="body2"
                fontSize={13}
                className="font-helvetica-bold"
                sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
              >
                <FaReact style={{ color: '#00d7ff' }} />
                React,
              </Typography>
              &nbsp;
              <Typography
                variant="body2"
                fontSize={13}
                className="font-helvetica-bold"
                sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
              >
                <DiNodejsSmall style={{ color: '#539e43' }} /> Node &{' '}
              </Typography>
              &nbsp;
              <Typography
                variant="body2"
                fontSize={13}
                className="font-helvetica-bold"
                sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
              >
                <RiFlutterFill style={{ color: '#66b5f7' }} /> Flutter
              </Typography>
              &nbsp;
            </Box>
          </Stack>
          not another plug & play site.
        </Typography>
      </Stack>
      <Box
        component="img"
        src={section1_bg}
        alt="hero"
        sx={{
          width: '100%',
          borderRadius: 2,
          marginBottom: '-120px',
          marginTop: '-20px',
          zIndex: 3,
          position: 'relative',
          height: screenWidth > 480 ? 'auto' : '450px',
          objectFit: screenWidth > 480 ? 'fill' : 'cover',
        }}
      />

      <Stack sx={{ backgroundColor: 'white', pt: '120px', position: 'relative' }}>
        <Stack textAlign={'center'} mb={2}>
          <Typography variant="h5" className="font-helvetica-bold">
            E Commerce
          </Typography>
          <Typography
            variant="body1"
            className="font-helvetica"
            fontWeight={400}
            sx={{
              fontSize: '20px',
              lineHeight: '18px',
            }}
          >
            everyone see!
          </Typography>
        </Stack>

        <Box
          component="img"
          src={section1_image}
          alt="hero"
          sx={{
            width: '100%',
            borderRadius: 2,
            marginBottom: '-170px',
            zIndex: 2,
            // px: 4
            mb: 5,
          }}
        />
      </Stack>
    </Box>
  );
}
